import { render, staticRenderFns } from "./vehiclePage.vue?vue&type=template&id=98277168&scoped=true&"
import script from "./vehiclePage.vue?vue&type=script&lang=js&"
export * from "./vehiclePage.vue?vue&type=script&lang=js&"
import style0 from "./vehiclePage.vue?vue&type=style&index=0&id=98277168&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98277168",
  null
  
)

export default component.exports